export default () => ({
  makes: []
})



// WEBPACK FOOTER //
// ./src/store/modules/make/state.js